import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

const EditCohabitantForm = (props) => {

  console.log(props);
  
  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const params = {
      first_name: formData.get("first_name"),
      last_name: formData.get("last_name"),
      relation: formData.get("relation"),
      date_of_birth: formData.get("date_of_birth"),
    };
    props.updateCohabitant(props.id, params);
  };
  
  return (
    <>
      <Form className="form pb-5 d-flex" onSubmit={handleSubmit}>
        <div>
          <h3 className="text-center">Baby details</h3>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>First Name</u></Form.Label>
            <Form.Control
              htmlFor="first_name"
              id="first_name"
              name="first_name"
              type="text"
              defaultValue={props.first_name}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Last Name</u></Form.Label>
            <Form.Control
              htmlFor="last_name"
              id="last_name"
              name="last_name"
              type="text"
              defaultValue={props.last_name}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Relation</u></Form.Label>
            <Form.Control
              htmlFor="relation"
              id="relation"
              name="relation"
              type="text"
              defaultValue={props.relation}
            />
          </Form.Group>
          <Form.Group className="border border-dark rounded m-1 text-center">
            <Form.Label><u>Date of birth</u></Form.Label>
            <Form.Control
              htmlFor="date_of_birth"
              id="date_of_birth"
              name="date_of_birth"
              type="text"
              defaultValue={props.date_of_birth}
            />
          </Form.Group>
          
        </div>

        <Button
          variant="primary"
          className="position-fixed bottom-50 end-0 py-3 mb-3"
          type="submit"
        >
          Update Cohabitant
        </Button>
      </Form>
    </>
  );
}

export default EditCohabitantForm